import { Injectable, inject } from '@angular/core';
import {
  ActivatedRoute,
  NavigationBehaviorOptions,
  NavigationExtras,
  Router,
} from '@angular/router';
import { Observable } from 'rxjs';
import { fromPromise } from 'rxjs/internal/observable/innerFrom';
import { blank, Nillable, valueOrUndefined } from '@web/utils';
import { RouteProviderService } from '../providers/route-provider.service';
import { RouterLink } from '../types/router-link';

@Injectable({
  providedIn: 'root',
})
export class NavigatorService {
  private readonly provider = inject(RouteProviderService);
  private readonly router = inject(Router);

  public navigateByExternalLink(link: string): void {
    window.location.replace(link);
  }

  public changeQueryParams(
    activatedRoute: ActivatedRoute,
    extras: Pick<NavigationExtras, 'queryParams' | 'queryParamsHandling'>,
  ): void {
    void this.router.navigate([], { relativeTo: activatedRoute, ...extras });
  }

  public changeQueryParamsAsync(
    activatedRoute: ActivatedRoute,
    extras: Pick<NavigationExtras, 'queryParams' | 'queryParamsHandling'>,
  ): Observable<void> {
    return fromPromise(
      this.router.navigate([], { relativeTo: activatedRoute, ...extras }),
    ).pipe(blank());
  }

  public navigateByCustomLink(
    link: string,
    extras?: Nillable<NavigationBehaviorOptions>,
  ): void {
    void this.router.navigateByUrl(
      this.router.parseUrl(link),
      valueOrUndefined(extras),
    );
  }

  public navigateByRouterLink(
    routerLink: (provider: RouteProviderService) => RouterLink,
    extras?: Nillable<NavigationExtras>,
  ): void {
    void this.router.navigate(
      routerLink(this.provider),
      valueOrUndefined(extras),
    );
  }

  public navigateByRouterLinkAsync(
    routerLink: (provider: RouteProviderService) => RouterLink,
    extras?: Nillable<NavigationExtras>,
  ): Observable<void> {
    return fromPromise(
      this.router.navigate(routerLink(this.provider), valueOrUndefined(extras)),
    ).pipe(blank());
  }
}
